var _line, _circle, _circle2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommission(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.8182,
    y1: 18.4039,
    x2: 20.5858,
    y2: 11.6363,
    stroke: "#24D1A8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6364,
    cy: 11.6364,
    r: 1,
    fill: "#0EF1BC",
    stroke: "#0EF1BC",
    strokeWidth: 1.27273
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5455,
    cy: 18.1818,
    r: 1,
    fill: "#0EF1BC",
    stroke: "#0EF1BC",
    strokeWidth: 1.27273
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.43516 20.8596C10.9561 22.5462 13.1369 23.6413 15.5736 23.9072C18.0113 24.1733 20.5138 23.5875 22.5939 22.2619C24.6733 20.9366 26.1663 18.9776 26.8094 16.779C27.4513 14.5841 27.2055 12.2943 26.1298 10.3402C25.0529 8.38394 23.2067 6.87861 20.9224 6.13507C18.6362 5.39089 16.0837 5.46751 13.7609 6.3627C11.4384 7.25781 9.53173 8.89926 8.39517 10.9529C7.26014 13.0037 6.97235 15.319 7.56149 17.4577",
    stroke: "#0BC196",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54298 17.3606L5.13621 19.8513C4.47356 20.5371 5.05554 21.673 5.99923 21.5358L9.59434 21.013",
    stroke: "#0BC196",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommission);
export default __webpack_public_path__ + "static/media/commission.9842fa6894c04e54ab33c252d8df9606.svg";
export { ForwardRef as ReactComponent };